/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unsaved_Changes_MsgInputs */

const en_unsaved_changes_msg = /** @type {(inputs: Unsaved_Changes_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsaved Changes`)
};

const id_unsaved_changes_msg = /** @type {(inputs: Unsaved_Changes_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan Belum Disimpan`)
};

/** @type {(inputs: Unsaved_Changes_MsgInputs) => LocalizedString} */
const es_unsaved_changes_msg = en_unsaved_changes_msg;

/** @type {(inputs: Unsaved_Changes_MsgInputs) => LocalizedString} */
const fr_unsaved_changes_msg = en_unsaved_changes_msg;

/** @type {(inputs: Unsaved_Changes_MsgInputs) => LocalizedString} */
const de_unsaved_changes_msg = en_unsaved_changes_msg;

/** @type {(inputs: Unsaved_Changes_MsgInputs) => LocalizedString} */
const ja_unsaved_changes_msg = en_unsaved_changes_msg;

/** @type {(inputs: Unsaved_Changes_MsgInputs) => LocalizedString} */
const zh_unsaved_changes_msg = en_unsaved_changes_msg;

/** @type {(inputs: Unsaved_Changes_MsgInputs) => LocalizedString} */
const ar_unsaved_changes_msg = en_unsaved_changes_msg;

/** @type {(inputs: Unsaved_Changes_MsgInputs) => LocalizedString} */
const it_unsaved_changes_msg = en_unsaved_changes_msg;

/** @type {(inputs: Unsaved_Changes_MsgInputs) => LocalizedString} */
const ru_unsaved_changes_msg = en_unsaved_changes_msg;

/** @type {(inputs: Unsaved_Changes_MsgInputs) => LocalizedString} */
const pt_unsaved_changes_msg = en_unsaved_changes_msg;

/** @type {(inputs: Unsaved_Changes_MsgInputs) => LocalizedString} */
const ko_unsaved_changes_msg = en_unsaved_changes_msg;

/**
* | output |
* | --- |
* | "Unsaved Changes" |
*
* @param {Unsaved_Changes_MsgInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const unsaved_changes_msg = /** @type {((inputs?: Unsaved_Changes_MsgInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unsaved_Changes_MsgInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unsaved_changes_msg(inputs)
	if (locale === "es") return es_unsaved_changes_msg(inputs)
	if (locale === "fr") return fr_unsaved_changes_msg(inputs)
	if (locale === "de") return de_unsaved_changes_msg(inputs)
	if (locale === "ja") return ja_unsaved_changes_msg(inputs)
	if (locale === "zh") return zh_unsaved_changes_msg(inputs)
	if (locale === "ar") return ar_unsaved_changes_msg(inputs)
	if (locale === "id") return id_unsaved_changes_msg(inputs)
	if (locale === "it") return it_unsaved_changes_msg(inputs)
	if (locale === "ru") return ru_unsaved_changes_msg(inputs)
	if (locale === "pt") return pt_unsaved_changes_msg(inputs)
	return ko_unsaved_changes_msg(inputs)
});